import { useCallback } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { GASv3 } from "../../../../../../../analytics/atl-analytics/gasv3";

export const useUserSegmentationEvents = () => {
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const fireTeamTypeProcessedEvent = useCallback(
        (teamType: string, additionalAttributes: object = {}) => {
            const eventData = {
                eventType: "track",
                action: "processed",
                actionSubject: "teamType",
                attributes: GASv3.enrichEventData({
                    teamType,
                    ...additionalAttributes
                })
            };

            createAnalyticsEvent(eventData).fire();
        },
        [createAnalyticsEvent]
    );

    return {
        fireTeamTypeProcessedEvent
    };
};
